import { render, staticRenderFns } from "./add_request.vue?vue&type=template&id=4bdaf2ff&scoped=true"
import script from "./add_request.vue?vue&type=script&lang=js"
export * from "./add_request.vue?vue&type=script&lang=js"
import style0 from "./add_request.vue?vue&type=style&index=0&id=4bdaf2ff&prod&scoped=true&lang=css"
import style1 from "./add_request.vue?vue&type=style&index=1&id=4bdaf2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdaf2ff",
  null
  
)

export default component.exports